"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRouter = void 0;
const utils_1 = require("@obvio/utils");
const router_1 = require("next/router");
const react_1 = require("react");
const useTranslation_1 = require("./useTranslation");
const href_1 = require("../href");
const locales_1 = require("../locales");
const routerUrl_1 = require("../routerUrl");
function useRouter() {
    const { locale } = (0, useTranslation_1.useTranslation)();
    const nextRouter = (0, router_1.useRouter)();
    const pathname = (0, locales_1.delocalizeRoute)(nextRouter.pathname, locale);
    const asPath = (0, locales_1.delocalizeRoute)(nextRouter.asPath, locale);
    const { query, catchAll } = (0, react_1.useMemo)(() => Object.keys((nextRouter === null || nextRouter === void 0 ? void 0 : nextRouter.query) || {}).reduce((acc, k) => {
        const v = nextRouter.query[k];
        if (typeof v === 'string') {
            (0, utils_1.set)(acc.query, k, v);
        }
        else if (Array.isArray(v)) {
            (0, utils_1.set)(acc, 'catchAll', v);
        }
        return acc;
    }, { query: {}, catchAll: [] }), [nextRouter]);
    const controller = (0, react_1.useMemo)(() => ({
        push: nextRouter.push,
        replace: nextRouter.replace,
        prefetch: nextRouter.prefetch,
    }), [nextRouter.push, nextRouter.replace, nextRouter.prefetch]);
    const routerBack = nextRouter.back;
    const [push, replace, prefetch] = (0, react_1.useMemo)(() => ['push', 'replace', 'prefetch'].map((method) => (href, ...args) => controller[method](...(Array.isArray(href) ? href : (0, routerUrl_1.routerUrl)(href, locale)), ...args)), [controller, locale]);
    const back = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () { return (window.history.state.index > 0 ? routerBack() : push('/')); }), [push, routerBack]);
    const setQuery = (0, react_1.useCallback)((cbParams) => __awaiter(this, void 0, void 0, function* () {
        const newQuery = typeof cbParams === 'function' ? cbParams(query) : cbParams;
        const { pathname: currentPath, hash } = new href_1.Href(asPath);
        yield push(new href_1.Href(currentPath, newQuery, hash), { shallow: true });
    }), [asPath, query, push]);
    const setParam = (0, react_1.useCallback)((k, v, add) => setQuery((current) => {
        var _a;
        const newQuery = Object.assign({}, current);
        if (add) {
            const currentValue = newQuery[k];
            newQuery[k] = [
                ...((_a = currentValue === null || currentValue === void 0 ? void 0 : currentValue.split(',')) !== null && _a !== void 0 ? _a : []),
                ...(v ? [v] : []),
            ].join(',');
        }
        else {
            newQuery[k] = v !== null && v !== void 0 ? v : '';
        }
        return newQuery;
    }), [setQuery]);
    const removeParam = (0, react_1.useCallback)((k) => setQuery((_a) => {
        var _b = k, _ = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        return rest;
    }), [setQuery]);
    const hasParam = (0, react_1.useCallback)((param) => (0, utils_1.has)(query, param), [query]);
    return (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, nextRouter), { query,
        catchAll,
        push,
        replace,
        prefetch,
        back,
        setParam,
        hasParam,
        removeParam,
        setQuery,
        pathname,
        asPath, localisedPathname: nextRouter.pathname, localisedAsPath: nextRouter.asPath })), [
        nextRouter,
        query,
        catchAll,
        push,
        replace,
        prefetch,
        back,
        setParam,
        hasParam,
        removeParam,
        setQuery,
        pathname,
        asPath,
    ]);
}
exports.useRouter = useRouter;
